import React, { memo, useState } from "react";
import { FormMain } from "./styles/FormMainStyle";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import AuthInput from "../../shared/authinput";
import MainButton from "../../shared/Button";
import { useParams } from "react-router-dom";
import { AddQuotationByID } from "../../../services/admin/dispatche";
import { toast } from "react-hot-toast";
import NotFoundIcon from "../../shared/NotFoundIcon";

const Quotation = ({ data = "" }) => {
  const { id } = useParams();
  const [Approveloading, setApproveloading] = useState(false);
  const [rejectloading, setrejectloading] = useState(false);
  const [ButtonHide, setButtonHide] = useState(false);

  const validationSchema = Yup.object().shape({
    price: Yup.string()
      .required("Price is required")
      .test(
        "is-positive-integer",
        "Please enter a positive integer",
        (value) => {
          if (!value) return false;
          const isPositiveInteger = /^[1-9]\d*$/.test(value);
          return isPositiveInteger;
        }
      ),
  });

  const initialValues = {
    price: data?.price || "",
  };
  const handleSubmit = async (values) => {
    const Body = {
      price: values.price,
      status: "approve",
    };
    const res = await AddQuotationByID(setApproveloading, id, Body);
    if (res.status === 200) {
      toast.success(res?.data?.message);
      setButtonHide(true);
    }
  };

  const RejectHandler = async () => {
    const Body = {
      status: "reject",
    };
    const res = await AddQuotationByID(setrejectloading, id, Body);
    if (res.status === 200) {
      toast.success(res?.data?.message);
      setButtonHide(true);
    }
  };

  return (
    <FormMain>
      {data && Object?.keys(data)?.length > 0 ? (
        <>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {(formik) => (
              <Form autocomplete="off">
                <Field
                  type="text"
                  name="price"
                  label="Quotation"
                  component={AuthInput}
                  placeholder="Enter Quotation"
                />
                <div className="ButtonMain">
                  {data?.status === "pending" && !ButtonHide && (
                    <>
                      <MainButton
                        type="submit"
                        label="Approve"
                        MT="200"
                        isLoading={Approveloading}
                      />
                      <MainButton
                        type="button"
                        label="Reject"
                        border={true}
                        MT="200"
                        onClick={RejectHandler}
                        isLoading={rejectloading}
                      />
                    </>
                  )}
                </div>
              </Form>
            )}
          </Formik>
        </>
      ) : (
        <NotFoundIcon MT="20" IconWidth="17" />
      )}
    </FormMain>
  );
};

export default memo(Quotation);
